import { SentimentDistribution, SentimentLabel } from '@/common/model/media/sentiment'
import { signedFixed } from '@/common/util/number'

import { BadgeType } from '@/components/view/atoms/badge/Badge'
import { TextColor } from '@/components/view/atoms/text/Text'

// センチメント分析の analysis_type 識別子
export const SENTIMENT_ANALYSIS_TYPE = 'sentiment'

// 競合は最大5社まで
export const MAX_COMPETITORS = 5

// センチメント別の表示色（ニュートラルは中立を表すグレー）
export const SENTIMENT_COLORS: Record<SentimentLabel, string> = {
  positive: '#3AB795',
  neutral: '#D3D9E1',
  negative: '#EE4C7C'
}

// ドーナツグラフの系列色（ポジティブ→ニュートラル→ネガティブの順）
export const SENTIMENT_CHART_COLORS = [
  SENTIMENT_COLORS.positive,
  SENTIMENT_COLORS.neutral,
  SENTIMENT_COLORS.negative
]

// センチメント別の日本語ラベル
export const SENTIMENT_LABELS: Record<SentimentLabel, string> = {
  positive: 'ポジティブ',
  neutral: 'ニュートラル',
  negative: 'ネガティブ'
}

// 文字列からセンチメント種別を正規化（不明はニュートラル扱い）
export const normalizeSentiment = (value: string | undefined): SentimentLabel => {
  const s = (value ?? '').toLowerCase()
  return s === 'positive' || s === 'negative' ? s : 'neutral'
}

// センチメントスコア（-1.0〜1.0）の文字色。正=ポジ / 負=ネガ / 0=中立
export const scoreTextColor = (score: number | null | undefined): TextColor => {
  if (score == null || score === 0) return TextColor.PRIMARY
  return score > 0 ? TextColor.SUCCESS : TextColor.CRITICAL
}

// センチメント別のバッジ種別
export const sentimentBadgeType = (label: SentimentLabel): BadgeType => {
  switch (label) {
    case 'positive':
      return BadgeType.SUCCESS
    case 'negative':
      return BadgeType.CRITICAL
    default:
      return BadgeType.DEFAULT
  }
}

// スコアを符号付きで表示（例: +0.35 / -0.30）
export const signedScore = (score: number | null | undefined): string => signedFixed(score)

// 推奨度（高／中／低）の文字色。AIの回答値に合わせて日本語・英語の両方を判定する
export const recommendationLevelColor = (level: string | null | undefined): TextColor => {
  const v = (level ?? '').toLowerCase()
  if (v.includes('高') || v === 'high') return TextColor.CRITICAL
  if (v.includes('中') || v === 'medium') return TextColor.CAUTION
  return TextColor.SECONDARY
}

// 分布を [{ label, value, color }] の表示用配列へ
export const distributionRows = (
  distribution: SentimentDistribution
): { key: SentimentLabel; label: string; value: number; color: string }[] =>
  (['positive', 'neutral', 'negative'] as SentimentLabel[]).map((key) => ({
    key,
    label: SENTIMENT_LABELS[key],
    value: distribution[key] ?? 0,
    color: SENTIMENT_COLORS[key]
  }))
